var Haiku = require("@haiku/core");
module.exports = {
  metadata: {
    username: "taylor+taylor@haiku.ai",
    uuid: "ad18a731-ed77-4085-88b7-419d3fe4f2f8",
    organization: "taylor",
    project: "heroine",
    branch: "master",
    folder: "/Users/taylorpoe/.haiku/projects/taylor/heroine",
    version: "0.0.18",
    root: "https://cdn.haiku.ai/e062580c-8941-425f-9ce7-f01d8d3a6bef/07ee961d5f9b270810efecb4f5013685c38388c4/",
    core: "4.2.0",
    title: "Purp",
    type: "haiku",
    relpath: "code/purp/code.js"
  },
  options: {},
  states: { finished: { type: "boolean", value: false, edited: true } },
  eventHandlers: {
    "haiku:Purp-f2e1bcfe30c0d997": {
      "timeline:Default:0": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      playPurp: {
        handler: function(component, element, target, event) {
          let frame = this.state.finished ? 90 : 1;
          this.getDefaultTimeline().gotoAndPlay(frame);
        }
      },
      "timeline:Default:160": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      },
      "timeline:Default:89": {
        handler: function(component, element, target, event) {
          this.getDefaultTimeline().pause();
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:7db6009db2ac": {
        strokeWidth: 3,
        x: 1.5,
        y: 1.5,
        width: 467,
        height: 96,
        rx: 10
      },
      "haiku:4925054d1795": {
        d:
          "M0.0420489015,63.5210791 C3.99878974,69.0604301 10.2599299,71.8301057 18.8254693,71.8301057 C31.6737783,71.8301057 34.4108628,60.4750263 48.964451,60.4750263 C63.5180392,60.4750263 62.5230909,71.8301057 77.0831232,71.8301057 C91.6431556,71.8301057 92.137195,60.4750263 107.162638,60.4750263 C122.188081,60.4750263 122.294536,71.8301057 137.18617,71.8301057 C152.077804,71.8301057 152.409548,60.4750263 166.739698,60.4750263 C181.069848,60.4750263 184.216453,74.8761585 197.977643,74.8761585"
      },
      "haiku:fbdd0f62c9bb": {
        strokeWidth: 4,
        "translation.x": 1,
        "translation.y": 3
      },
      "haiku:303e9b0433ec": {
        d:
          "M1.56586001,1.50185886 C6.50672678,8.38735672 13.2599299,11.8301057 21.8254693,11.8301057 C34.6737783,11.8301057 37.4108628,0.475026307 51.964451,0.475026307 C66.5180392,0.475026307 65.5230909,11.8301057 80.0831232,11.8301057 C94.6431556,11.8301057 95.137195,0.475026307 110.162638,0.475026307 C125.188081,0.475026307 125.294536,11.8301057 140.18617,11.8301057 C155.077804,11.8301057 155.409548,0.475026307 169.739698,0.475026307 C184.069848,0.475026307 184.507153,11.8513869 198.268343,11.8513869"
      },
      "haiku:6f5eae59e602": {
        d:
          "M0.721694804,20.4750263 C6.22533838,28.0450792 13.2599299,31.8301057 21.8254693,31.8301057 C34.6737783,31.8301057 37.4108628,20.4750263 51.964451,20.4750263 C66.5180392,20.4750263 65.5230909,31.8301057 80.0831232,31.8301057 C94.6431556,31.8301057 95.137195,20.4750263 110.162638,20.4750263 C125.188081,20.4750263 125.294536,31.8301057 140.18617,31.8301057 C155.077804,31.8301057 155.409548,20.4750263 169.739698,20.4750263 C184.069848,20.4750263 184.896099,31.8301057 198.657289,31.8301057"
      },
      "haiku:742c5ed07ba4": {
        d:
          "M0.721694804,40.4750263 C6.22533838,48.0450792 13.2599299,51.8301057 21.8254693,51.8301057 C34.6737783,51.8301057 37.4108628,40.4750263 51.964451,40.4750263 C66.5180392,40.4750263 65.5230909,51.8301057 80.0831232,51.8301057 C94.6431556,51.8301057 95.137195,40.4750263 110.162638,40.4750263 C125.188081,40.4750263 125.294536,51.8301057 140.18617,51.8301057 C155.077804,51.8301057 155.409548,40.4750263 169.739698,40.4750263 C184.069848,40.4750263 184.896099,51.8301057 198.657289,51.8301057"
      },
      "haiku:a9a3a10adeb6": {
        d:
          "M0.721694804,60.4750263 C6.22533838,68.0450792 13.2599299,71.8301057 21.8254693,71.8301057 C34.6737783,71.8301057 37.4108628,60.4750263 51.964451,60.4750263 C66.5180392,60.4750263 65.5230909,71.8301057 80.0831232,71.8301057 C94.6431556,71.8301057 95.137195,60.4750263 110.162638,60.4750263 C125.188081,60.4750263 125.294536,71.8301057 140.18617,71.8301057 C155.077804,71.8301057 155.409548,60.4750263 169.739698,60.4750263 C184.069848,60.4750263 184.896099,71.8301057 198.657289,71.8301057"
      },
      "haiku:1edf8ea9bd6f": {
        d:
          "M0.721694804,80.4750263 C6.22533838,88.0450792 13.2599299,91.8301057 21.8254693,91.8301057 C34.6737783,91.8301057 37.4108628,80.4750263 51.964451,80.4750263 C66.5180392,80.4750263 65.5230909,91.8301057 80.0831232,91.8301057 C94.6431556,91.8301057 95.137195,80.4750263 110.162638,80.4750263 C125.188081,80.4750263 125.294536,91.8301057 140.18617,91.8301057 C155.077804,91.8301057 155.409548,80.4750263 169.739698,80.4750263 C184.069848,80.4750263 184.896099,91.8301057 198.657289,91.8301057"
      },
      "haiku:307e63301a92": { "translation.x": 181 },
      "haiku:ed0e7cd79452": {
        d:
          "M0.0420489015,23.5210791 C3.99878974,29.0604301 10.2599299,31.8301057 18.8254693,31.8301057 C31.6737783,31.8301057 34.4108628,20.4750263 48.964451,20.4750263 C63.5180392,20.4750263 62.5230909,31.8301057 77.0831232,31.8301057 C91.6431556,31.8301057 92.137195,20.4750263 107.162638,20.4750263 C122.188081,20.4750263 122.294536,31.8301057 137.18617,31.8301057 C152.077804,31.8301057 152.409548,20.4750263 166.739698,20.4750263 C181.069848,20.4750263 184.216453,34.8761585 197.977643,34.8761585"
      },
      "haiku:9812a9a841e9": {
        d:
          "M0.0420489015,43.5210791 C3.99878974,49.0604301 10.2599299,51.8301057 18.8254693,51.8301057 C31.6737783,51.8301057 34.4108628,40.4750263 48.964451,40.4750263 C63.5180392,40.4750263 62.5230909,51.8301057 77.0831232,51.8301057 C91.6431556,51.8301057 92.137195,40.4750263 107.162638,40.4750263 C122.188081,40.4750263 122.294536,51.8301057 137.18617,51.8301057 C152.077804,51.8301057 152.409548,40.4750263 166.739698,40.4750263 C181.069848,40.4750263 184.216453,54.8761585 197.977643,54.8761585"
      },
      "haiku:1c3294afdb1f": {
        d:
          "M0.0420489015,63.5210791 C3.99878974,69.0604301 10.2599299,71.8301057 18.8254693,71.8301057 C31.6737783,71.8301057 34.4108628,60.4750263 48.964451,60.4750263 C63.5180392,60.4750263 62.5230909,71.8301057 77.0831232,71.8301057 C91.6431556,71.8301057 92.137195,60.4750263 107.162638,60.4750263 C122.188081,60.4750263 122.294536,71.8301057 137.18617,71.8301057 C152.077804,71.8301057 152.409548,60.4750263 166.739698,60.4750263 C181.069848,60.4750263 184.216453,74.8761585 197.977643,74.8761585"
      },
      "haiku:944cd3464144": {
        d:
          "M0.0420489015,83.5210791 C3.99878974,89.0604301 10.2599299,91.8301057 18.8254693,91.8301057 C31.6737783,91.8301057 34.4108628,80.4750263 48.964451,80.4750263 C63.5180392,80.4750263 62.5230909,91.8301057 77.0831232,91.8301057 C91.6431556,91.8301057 92.137195,80.4750263 107.162638,80.4750263 C122.188081,80.4750263 122.294536,91.8301057 137.18617,91.8301057 C152.077804,91.8301057 152.409548,80.4750263 166.739698,80.4750263 C181.069848,80.4750263 184.216453,94.8761585 197.977643,94.8761585"
      },
      "haiku:c6f2a33be2d4": {
        d:
          "M0.0420489015,3.52107915 C3.99878974,9.06043015 10.2599299,11.8301057 18.8254693,11.8301057 C31.6737783,11.8301057 34.4108628,0.475026307 48.964451,0.475026307 C63.5180392,0.475026307 62.5230909,11.8301057 77.0831232,11.8301057 C91.6431556,11.8301057 92.137195,0.475026307 107.162638,0.475026307 C122.188081,0.475026307 122.294536,11.8301057 137.18617,11.8301057 C152.077804,11.8301057 152.409548,0.475026307 166.739698,0.475026307 C181.069848,0.475026307 184.216453,14.8761585 197.977643,14.8761585"
      },
      "haiku:4a41d35137b3": {
        strokeWidth: 3,
        x: 1.5,
        y: 1.5,
        width: 467,
        height: 96,
        rx: 10
      },
      "haiku:e0024529a43f": {
        strokeWidth: 4,
        "translation.x": 1,
        "translation.y": 3
      },
      "haiku:0a6ff667031d": {
        d:
          "M1.56586001,1.50185886 C6.50672678,8.38735672 13.2599299,11.8301057 21.8254693,11.8301057 C34.6737783,11.8301057 37.4108628,0.475026307 51.964451,0.475026307 C66.5180392,0.475026307 65.5230909,11.8301057 80.0831232,11.8301057 C94.6431556,11.8301057 95.137195,0.475026307 110.162638,0.475026307 C125.188081,0.475026307 125.294536,11.8301057 140.18617,11.8301057 C155.077804,11.8301057 155.409548,0.475026307 169.739698,0.475026307 C184.069848,0.475026307 184.507153,11.8513869 198.268343,11.8513869"
      },
      "haiku:6c3b8c16e446": {
        d:
          "M0.721694804,20.4750263 C6.22533838,28.0450792 13.2599299,31.8301057 21.8254693,31.8301057 C34.6737783,31.8301057 37.4108628,20.4750263 51.964451,20.4750263 C66.5180392,20.4750263 65.5230909,31.8301057 80.0831232,31.8301057 C94.6431556,31.8301057 95.137195,20.4750263 110.162638,20.4750263 C125.188081,20.4750263 125.294536,31.8301057 140.18617,31.8301057 C155.077804,31.8301057 155.409548,20.4750263 169.739698,20.4750263 C184.069848,20.4750263 184.896099,31.8301057 198.657289,31.8301057"
      },
      "haiku:1d5523a01baf": {
        d:
          "M0.721694804,40.4750263 C6.22533838,48.0450792 13.2599299,51.8301057 21.8254693,51.8301057 C34.6737783,51.8301057 37.4108628,40.4750263 51.964451,40.4750263 C66.5180392,40.4750263 65.5230909,51.8301057 80.0831232,51.8301057 C94.6431556,51.8301057 95.137195,40.4750263 110.162638,40.4750263 C125.188081,40.4750263 125.294536,51.8301057 140.18617,51.8301057 C155.077804,51.8301057 155.409548,40.4750263 169.739698,40.4750263 C184.069848,40.4750263 184.896099,51.8301057 198.657289,51.8301057"
      },
      "haiku:1b0a84281d30": {
        d:
          "M0.721694804,60.4750263 C6.22533838,68.0450792 13.2599299,71.8301057 21.8254693,71.8301057 C34.6737783,71.8301057 37.4108628,60.4750263 51.964451,60.4750263 C66.5180392,60.4750263 65.5230909,71.8301057 80.0831232,71.8301057 C94.6431556,71.8301057 95.137195,60.4750263 110.162638,60.4750263 C125.188081,60.4750263 125.294536,71.8301057 140.18617,71.8301057 C155.077804,71.8301057 155.409548,60.4750263 169.739698,60.4750263 C184.069848,60.4750263 184.896099,71.8301057 198.657289,71.8301057"
      },
      "haiku:3671bc23729f": {
        d:
          "M0.721694804,80.4750263 C6.22533838,88.0450792 13.2599299,91.8301057 21.8254693,91.8301057 C34.6737783,91.8301057 37.4108628,80.4750263 51.964451,80.4750263 C66.5180392,80.4750263 65.5230909,91.8301057 80.0831232,91.8301057 C94.6431556,91.8301057 95.137195,80.4750263 110.162638,80.4750263 C125.188081,80.4750263 125.294536,91.8301057 140.18617,91.8301057 C155.077804,91.8301057 155.409548,80.4750263 169.739698,80.4750263 C184.069848,80.4750263 184.896099,91.8301057 198.657289,91.8301057"
      },
      "haiku:845a2303eb91": { "translation.x": 181 },
      "haiku:6444ce76a008": {
        d:
          "M0.0420489015,23.5210791 C3.99878974,29.0604301 10.2599299,31.8301057 18.8254693,31.8301057 C31.6737783,31.8301057 34.4108628,20.4750263 48.964451,20.4750263 C63.5180392,20.4750263 62.5230909,31.8301057 77.0831232,31.8301057 C91.6431556,31.8301057 92.137195,20.4750263 107.162638,20.4750263 C122.188081,20.4750263 122.294536,31.8301057 137.18617,31.8301057 C152.077804,31.8301057 152.409548,20.4750263 166.739698,20.4750263 C181.069848,20.4750263 184.216453,34.8761585 197.977643,34.8761585"
      },
      "haiku:fba70a0b449b": {
        d:
          "M0.0420489015,43.5210791 C3.99878974,49.0604301 10.2599299,51.8301057 18.8254693,51.8301057 C31.6737783,51.8301057 34.4108628,40.4750263 48.964451,40.4750263 C63.5180392,40.4750263 62.5230909,51.8301057 77.0831232,51.8301057 C91.6431556,51.8301057 92.137195,40.4750263 107.162638,40.4750263 C122.188081,40.4750263 122.294536,51.8301057 137.18617,51.8301057 C152.077804,51.8301057 152.409548,40.4750263 166.739698,40.4750263 C181.069848,40.4750263 184.216453,54.8761585 197.977643,54.8761585"
      },
      "haiku:Purp-f2e1bcfe30c0d997": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "visible",
        "style.overflowY": "visible",
        "sizeAbsolute.x": 612,
        "sizeAbsolute.y": 242,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:4f2fa68d1611": {
        d:
          "M0.0420489015,83.5210791 C3.99878974,89.0604301 10.2599299,91.8301057 18.8254693,91.8301057 C31.6737783,91.8301057 34.4108628,80.4750263 48.964451,80.4750263 C63.5180392,80.4750263 62.5230909,91.8301057 77.0831232,91.8301057 C91.6431556,91.8301057 92.137195,80.4750263 107.162638,80.4750263 C122.188081,80.4750263 122.294536,91.8301057 137.18617,91.8301057 C152.077804,91.8301057 152.409548,80.4750263 166.739698,80.4750263 C181.069848,80.4750263 184.216453,94.8761585 197.977643,94.8761585"
      },
      "haiku:a8719d442838": {
        d:
          "M0.0420489015,3.52107915 C3.99878974,9.06043015 10.2599299,11.8301057 18.8254693,11.8301057 C31.6737783,11.8301057 34.4108628,0.475026307 48.964451,0.475026307 C63.5180392,0.475026307 62.5230909,11.8301057 77.0831232,11.8301057 C91.6431556,11.8301057 92.137195,0.475026307 107.162638,0.475026307 C122.188081,0.475026307 122.294536,11.8301057 137.18617,11.8301057 C152.077804,11.8301057 152.409548,0.475026307 166.739698,0.475026307 C181.069848,0.475026307 184.216453,14.8761585 197.977643,14.8761585"
      },
      "haiku:Shadow-5e27259745b164ca": {
        "style.position": "absolute",
        "sizeAbsolute.y": 96.37615966796875,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 296,
        "translation.y": 129.688,
        "sizeAbsolute.x": 467,
        "sizeMode.x": 1,
        "style.overflow": "visible",
        "sizeMode.y": 1,
        "style.zIndex": { "0": { value: 3, edited: true } },
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.6, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.05, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.6, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.05, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": 0,
        "translation.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5
      },
      "haiku:38c65e4df8db-C44275-Filter-1-E0c5f5-e91ed39bc08a0ca9": {
        x: "-17.0%",
        y: "-23.2%",
        width: "134.1%",
        height: "147.5%",
        filterUnits: "objectBoundingBox"
      },
      "haiku:Fe-Offset-70fd8ff26505e5da": {
        dx: 0,
        dy: 2,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
      },
      "haiku:Fe-Gaussian-Blur-b48000dc81a09c79": {
        stdDeviation: 31,
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1"
      },
      "haiku:Fe-Color-Matrix-4daf996749b3ee38": {
        values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
        in: "shadowBlurOuter1",
        result: "shadowMatrixOuter1"
      },
      "haiku:Fe-Merge-Node-df9d06c46f4610a0": { in: "shadowMatrixOuter1" },
      "haiku:Fe-Merge-Node-26417114bd118f05": { in: "SourceGraphic" },
      "haiku:Group-ae50cc3f0920c688": {
        filter: "url(#38c65e4df8db-c44275)",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.585267857,
        "translation.x": -1.5,
        "translation.y": -1.5
      },
      "haiku:Ff849e99131d-Shadow-045fe4a9c0401b74": { stroke: "#1B2226" },
      "haiku:Thing-8ae68dd952dc3f0b": {
        "sizeMode.x": 1,
        "translation.y": 114.688,
        "style.margin": "0",
        "style.padding": "0",
        "style.border": "0",
        "translation.x": 316,
        "style.position": "absolute",
        "sizeAbsolute.x": 467,
        "style.overflow": "visible",
        "sizeAbsolute.y": 96.37615966796875,
        "sizeMode.y": 1,
        "style.zIndex": { "0": { value: 4, edited: true } },
        "translation.z": 20,
        opacity: {
          "0": { value: 0, edited: true },
          "517": { value: 1, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true },
          "517": { value: 0.6, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.05, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true },
          "517": { value: 0.6, edited: true, curve: "easeOutBack" },
          "1100": { value: 1, edited: true },
          "1500": {
            value: 0.9990206332956331,
            edited: true,
            curve: "easeInBack"
          },
          "2083": { value: 1.05, edited: true, curve: "easeOutBack" },
          "2667": { value: 1, edited: true }
        },
        "rotation.z": 0
      },
      "haiku:38c65e4df8db-5f993d-Filter-1-E0c5f5-9cdcc745e5f9001a": {
        x: "-17.0%",
        y: "-23.2%",
        width: "134.1%",
        height: "147.5%",
        filterUnits: "objectBoundingBox"
      },
      "haiku:Fe-Offset-33e8779e44fe29ff": {
        dx: 0,
        dy: 2,
        in: "SourceAlpha",
        result: "shadowOffsetOuter1"
      },
      "haiku:Fe-Gaussian-Blur-37d2de581be9511d": {
        stdDeviation: 31,
        in: "shadowOffsetOuter1",
        result: "shadowBlurOuter1"
      },
      "haiku:Fe-Color-Matrix-7295043cacd18b37": {
        values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0",
        in: "shadowBlurOuter1",
        result: "shadowMatrixOuter1"
      },
      "haiku:Fe-Merge-Node-6b7dcc09fdd5c0b2": { in: "shadowMatrixOuter1" },
      "haiku:Fe-Merge-Node-4486ef862f12ea2b": { in: "SourceGraphic" },
      "haiku:Group-0086b2a86a71fa2a": {
        filter: "url(#38c65e4df8db-5f993d)",
        fillRule: "nonzero",
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        opacity: 0.585267857,
        "translation.x": -1.5,
        "translation.y": -1.5
      },
      "haiku:52964a911b51-Thing-241fe91a1aae7cb4": { stroke: "#AC5FD6" },
      "haiku:Slot2-Lg-5854af7cec10c8a1": {
        "style.margin": "0",
        "sizeAbsolute.y": 99,
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 470,
        "sizeMode.x": 1,
        "style.position": "absolute",
        "sizeMode.y": 1,
        "translation.x": 317,
        "translation.y": 111,
        "style.zIndex": 1,
        opacity: {
          "0": { value: 1, edited: true },
          "517": { value: 0, edited: true }
        },
        "scale.x": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        },
        "scale.y": {
          "0": { value: 1, edited: true, curve: "easeInBack" },
          "517": { value: 0.1, edited: true }
        }
      },
      "haiku:Page-1-57077d3dbaf3e6a7": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Artboard-3-46bca45a08406cdb": {
        fill: "#1B2226",
        fillRule: "nonzero",
        "translation.x": -30,
        "translation.y": -132
      },
      "haiku:slot2_lg-b918e61fa0b6b864": {
        x: 30,
        y: 132,
        width: 470,
        height: 99,
        rx: 10
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Purp-f2e1bcfe30c0d997", "haiku-title": "Purp" },
    children: [
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Slot2-Lg-5854af7cec10c8a1",
          "haiku-title": "slot2_lg",
          "haiku-source": "designs/heroine.sketch.contents/slices/slot2_lg.svg"
        },
        children: [
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-57077d3dbaf3e6a7", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Artboard-3-46bca45a08406cdb",
                  id: "Artboard-3"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "slot2_lg-b918e61fa0b6b864",
                      id: "slot2_lg"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Thing-8ae68dd952dc3f0b",
          "haiku-title": "thing",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_purps.svg#52964a911b51"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-d527dc467b145167" },
            children: [
              {
                elementName: "filter",
                attributes: {
                  "haiku-id":
                    "38c65e4df8db-5f993d-Filter-1-E0c5f5-9cdcc745e5f9001a",
                  "haiku-title": "filter-1-e0c5f5",
                  id: "38c65e4df8db-5f993d"
                },
                children: [
                  {
                    elementName: "feOffset",
                    attributes: { "haiku-id": "Fe-Offset-33e8779e44fe29ff" },
                    children: []
                  },
                  {
                    elementName: "feGaussianBlur",
                    attributes: {
                      "haiku-id": "Fe-Gaussian-Blur-37d2de581be9511d"
                    },
                    children: []
                  },
                  {
                    elementName: "feColorMatrix",
                    attributes: {
                      "haiku-id": "Fe-Color-Matrix-7295043cacd18b37",
                      type: "matrix"
                    },
                    children: []
                  },
                  {
                    elementName: "feMerge",
                    attributes: { "haiku-id": "Fe-Merge-cb8577448ef0ecd7" },
                    children: [
                      {
                        elementName: "feMergeNode",
                        attributes: {
                          "haiku-id": "Fe-Merge-Node-6b7dcc09fdd5c0b2"
                        },
                        children: []
                      },
                      {
                        elementName: "feMergeNode",
                        attributes: {
                          "haiku-id": "Fe-Merge-Node-4486ef862f12ea2b"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-0086b2a86a71fa2a" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "52964a911b51-Thing-241fe91a1aae7cb4",
                  "haiku-title": "thing",
                  id: "52964a911b51"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "4a41d35137b3",
                      "haiku-title": "Rectangle-7-Copy-4",
                      id: "24c0d26bdf2d"
                    },
                    children: []
                  },
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "e0024529a43f",
                      "haiku-title": "squig",
                      id: "e8a3d846e872"
                    },
                    children: [
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "c63c4ffab410",
                          "haiku-title": "Group",
                          id: "3def815a453d"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "0a6ff667031d",
                              "haiku-title": "Path-3-Copy-4",
                              id: "e5c0edb03c69"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "6c3b8c16e446",
                              "haiku-title": "Path-3-Copy-5",
                              id: "fb146e324939"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "1d5523a01baf",
                              "haiku-title": "Path-3-Copy-6",
                              id: "0d49082bc22a"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "1b0a84281d30",
                              "haiku-title": "Path-3-Copy-7",
                              id: "59840d980431"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "3671bc23729f",
                              "haiku-title": "Path-3-Copy-8",
                              id: "5bee4f59b52c"
                            },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "845a2303eb91",
                          "haiku-title": "Group-Copy",
                          id: "0e8fcc84e6e8"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "6444ce76a008",
                              "haiku-title": "Path-3-Copy-5",
                              id: "fb146e324939"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "fba70a0b449b",
                              "haiku-title": "Path-3-Copy-10",
                              id: "1c992c29fc80"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "4925054d1795",
                              "haiku-title": "Path-3-Copy-11",
                              id: "ddc606bc943d"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "4f2fa68d1611",
                              "haiku-title": "Path-3-Copy-12",
                              id: "70d5f747b09c"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "a8719d442838",
                              "haiku-title": "Path-3-Copy-9",
                              id: "5d8c4a272501"
                            },
                            children: []
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Shadow-5e27259745b164ca",
          "haiku-title": "shadow",
          "haiku-source":
            "designs/heroine.sketch.contents/slices/ui_purps.svg#ff849e99131d"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-be2fadf458d3743c" },
            children: [
              {
                elementName: "filter",
                attributes: {
                  "haiku-id":
                    "38c65e4df8db-C44275-Filter-1-E0c5f5-e91ed39bc08a0ca9",
                  "haiku-title": "filter-1-e0c5f5",
                  id: "38c65e4df8db-c44275"
                },
                children: [
                  {
                    elementName: "feOffset",
                    attributes: { "haiku-id": "Fe-Offset-70fd8ff26505e5da" },
                    children: []
                  },
                  {
                    elementName: "feGaussianBlur",
                    attributes: {
                      "haiku-id": "Fe-Gaussian-Blur-b48000dc81a09c79"
                    },
                    children: []
                  },
                  {
                    elementName: "feColorMatrix",
                    attributes: {
                      "haiku-id": "Fe-Color-Matrix-4daf996749b3ee38",
                      type: "matrix"
                    },
                    children: []
                  },
                  {
                    elementName: "feMerge",
                    attributes: { "haiku-id": "Fe-Merge-b967bdca26750f5e" },
                    children: [
                      {
                        elementName: "feMergeNode",
                        attributes: {
                          "haiku-id": "Fe-Merge-Node-df9d06c46f4610a0"
                        },
                        children: []
                      },
                      {
                        elementName: "feMergeNode",
                        attributes: {
                          "haiku-id": "Fe-Merge-Node-26417114bd118f05"
                        },
                        children: []
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Group-ae50cc3f0920c688" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Ff849e99131d-Shadow-045fe4a9c0401b74",
                  "haiku-title": "shadow",
                  id: "ff849e99131d"
                },
                children: [
                  {
                    elementName: "rect",
                    attributes: {
                      "haiku-id": "7db6009db2ac",
                      "haiku-title": "Rectangle-7-Copy-4",
                      id: "24c0d26bdf2d"
                    },
                    children: []
                  },
                  {
                    elementName: "g",
                    attributes: {
                      "haiku-id": "fbdd0f62c9bb",
                      "haiku-title": "squig",
                      id: "e8a3d846e872"
                    },
                    children: [
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "7f4d4f79972d",
                          "haiku-title": "Group",
                          id: "3def815a453d"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "303e9b0433ec",
                              "haiku-title": "Path-3-Copy-4",
                              id: "e5c0edb03c69"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "6f5eae59e602",
                              "haiku-title": "Path-3-Copy-5",
                              id: "fb146e324939"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "742c5ed07ba4",
                              "haiku-title": "Path-3-Copy-6",
                              id: "0d49082bc22a"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "a9a3a10adeb6",
                              "haiku-title": "Path-3-Copy-7",
                              id: "59840d980431"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "1edf8ea9bd6f",
                              "haiku-title": "Path-3-Copy-8",
                              id: "5bee4f59b52c"
                            },
                            children: []
                          }
                        ]
                      },
                      {
                        elementName: "g",
                        attributes: {
                          "haiku-id": "307e63301a92",
                          "haiku-title": "Group-Copy",
                          id: "0e8fcc84e6e8"
                        },
                        children: [
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "ed0e7cd79452",
                              "haiku-title": "Path-3-Copy-5",
                              id: "fb146e324939"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "9812a9a841e9",
                              "haiku-title": "Path-3-Copy-10",
                              id: "1c992c29fc80"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "1c3294afdb1f",
                              "haiku-title": "Path-3-Copy-11",
                              id: "ddc606bc943d"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "944cd3464144",
                              "haiku-title": "Path-3-Copy-12",
                              id: "70d5f747b09c"
                            },
                            children: []
                          },
                          {
                            elementName: "path",
                            attributes: {
                              "haiku-id": "c6f2a33be2d4",
                              "haiku-title": "Path-3-Copy-9",
                              id: "5d8c4a272501"
                            },
                            children: []
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/taylor-heroine/code/purp/code.js
// module id = 526
// module chunks = 35783957827783